<template>
  <div class="chartTarget" style="height:100%;width:100%;">
    <!-- <p v-text="getTitle(this.ChartId)" v-if="getSeen(this.ChartId)"></p> -->
    <component :is="is" :data="chartData" :grid="grid" :toolbox="toolbox" :settings="chartSettings"></component>
    <!--:legend-visible="false"  :colors="colors"-->
  </div>
</template>

<script>
  export default {
    props: ["ChartId", "chartType"],
    // methods : {
    //   getTitle(id) {
    //     switch (id) {
    //       case "e":
    //         return "本周任务执行数量统计";
    //       break;
    //       default:
    //         return "图表";
    //     }
    //   },
    //   getSeen(id) {
    //     switch (id) {
    //       case "e":
    //         return true;
    //       break;
    //       default:
    //         return false;
    //     }
    //   }
    // },
    mounted() {
      switch (this.chartType) {
        case "histogram":
          this.is = "ve-map";
          this.chartSettings = {
            position: 'province/shanghai',
            label: {
              show: true,
              formatter: '{c}',
              position: 'inner'
            },
            roam: true,
            itemStyle: {
              normal: {
                borderColor: '#000'
              }
            },
            zoom: 1.2
          }
          this.chartData = {
            columns: ["行政区", "数量"],
            rows: [{
                "行政区": '黄浦区',
                "数量": 18
              },
              {
                "行政区": '徐汇区',
                "数量": 12
              },
              {
                "行政区": '长宁区',
                "数量": 5
              },
              {
                "行政区": '静安区',
                "数量": 2
              },
              {
                "行政区": '普陀区',
                "数量": 16
              },
              {
                "行政区": '虹口区',
                "数量": 11
              },
              {
                "行政区": "杨浦区",
                "数量": 19
              },
              {
                "行政区": "闵行区",
                "数量": 22
              },
              {
                "行政区": "宝山区",
                "数量": 14
              },
              {
                "行政区": "嘉定区",
                "数量": 5
              },
              {
                "行政区": "浦东新区",
                "数量": 6
              },
              {
                "行政区": "金山区",
                "数量": 7
              },
              {
                "行政区": "松江区",
                "数量": 5
              },
              {
                "行政区": "青浦区",
                "数量": 4
              },
              {
                "行政区": "奉贤区",
                "数量": 13
              },
              {
                "行政区": "崇明区",
                "数量": 12
              }
            ]
          }
          break;
        case "pie":
          this.is = "ve-pie";
          this.chartSettings = {
            label: {
              formatter: '{b} : {c}'
            }
          };
          this.chartData = {
            columns: ["类型", "数量"],
            rows: [{
                "类型": "离线",
                "数量": 18
              },
              {
                "类型": "任务执行",
                "数量": 12
              },
              {
                "类型": "空闲",
                "数量": 5
              },
              {
                "类型": "故障",
                "数量": 2
              }
            ]
          }
          break;
        case "pie_b":
          this.is = "ve-pie";
          this.chartSettings = {
            label: {
              formatter: '{b} : {c}'
            }
          };
          this.chartData = {
            columns: ["类型", "数量"],
            rows: [{
                "类型": "频率90.1",
                "数量": 8
              },
              {
                "类型": "频率96.5",
                "数量": 9
              },
              {
                "类型": "频率101.2",
                "数量": 5
              },
              {
                "类型": "频率105.3",
                "数量": 6
              }
            ]
          }
          break;
        case "pie_d":
          this.is = "ve-pie";
          this.chartSettings = {
            label: {
              formatter: '{b} : {c}'
            }
          };
          this.chartData = {
            columns: ["类型", "数量"],
            rows: [{
                "类型": "其他",
                "数量": 26
              },
              {
                "类型": "非法电台",
                "数量": 9
              },
            ]
          }
          break;
        case "pie_c":
          this.is = "ve-pie";
          this.chartSettings = {
            label: {
              formatter: '{b} : {c}'
            }
          };
          this.chartData = {
            columns: ["类型", "数量"],
            rows: [{
                "类型": "频率90.1",
                "数量": 18
              },
              {
                "类型": "频率96.5",
                "数量": 9
              },
              {
                "类型": "频率101.2",
                "数量": 10
              },
              {
                "类型": "频率105.3",
                "数量": 6
              }
            ]
          }
          break;
        case "line":
          this.is = "ve-line";
          this.chartSettings = {
            label: {
              show: true,
              formatter: '{@[1]}'
            }
          };
          this.chartData = {
            columns: ['日期', '数量'],
            rows: [{
                '日期': '1',
                '数量': 10
              }, {
                '日期': '2',
                '数量': 9
              },
              {
                '日期': '3',
                '数量': 13
              }, {
                '日期': '4',
                '数量': 10
              },
              {
                '日期': '5',
                '数量': 15
              }, {
                '日期': '6',
                '数量': 11
              },
              {
                '日期': '7',
                '数量': 19
              }, {
                '日期': '8',
                '数量': 13
              },
              {
                '日期': '9',
                '数量': 12
              }, {
                '日期': '10',
                '数量': 16
              },
              {
                '日期': '11',
                '数量': 5
              }, {
                '日期': '12',
                '数量': 9
              },
              {
                '日期': '13',
                '数量': 6
              }, {
                '日期': '14',
                '数量': 3
              },
              {
                '日期': '15',
                '数量': 8
              }, {
                '日期': '16',
                '数量': 13
              },
              {
                '日期': '17',
                '数量': 11
              }, {
                '日期': '18',
                '数量': 13
              },
              {
                '日期': '19',
                '数量': 9
              }, {
                '日期': '20',
                '数量': 9
              },
              {
                '日期': '21',
                '数量': 13
              }, {
                '日期': '22',
                '数量': 4
              },
              {
                '日期': '23',
                '数量': 14
              }, {
                '日期': '24',
                '数量': 3
              },
              {
                '日期': '25',
                '数量': 16
              }, {
                '日期': '26',
                '数量': 13
              },
              {
                '日期': '27',
                '数量': 19
              }, {
                '日期': '28',
                '数量': 13
              },
              {
                '日期': '29',
                '数量': 12
              }, {
                '日期': '30',
                '数量': 16
              }
            ]
          }
          break;
        case "line_b":
          this.is = "ve-line";
          this.chartSettings = {
            label: {
              show: true,
              formatter: '{@[1]}'
            }
          };
          this.chartData = {
            columns: ['日期', '数量'],
            rows: [{
                '日期': '1',
                '数量': 10
              }, {
                '日期': '2',
                '数量': 5
              },
              {
                '日期': '3',
                '数量': 13
              }, {
                '日期': '4',
                '数量': 8
              },
              {
                '日期': '5',
                '数量': 15
              }, {
                '日期': '6',
                '数量': 9
              },
              {
                '日期': '7',
                '数量': 14
              }, {
                '日期': '8',
                '数量': 15
              },
              {
                '日期': '9',
                '数量': 10
              }, {
                '日期': '10',
                '数量': 6
              },
              {
                '日期': '11',
                '数量': 9
              }, {
                '日期': '12',
                '数量': 10
              },
              {
                '日期': '13',
                '数量': 6
              }, {
                '日期': '14',
                '数量': 3
              },
              {
                '日期': '15',
                '数量': 0
              }, {
                '日期': '16',
                '数量': 0
              },
              {
                '日期': '17',
                '数量': 11
              }, {
                '日期': '18',
                '数量': 11
              },
              {
                '日期': '19',
                '数量': 10
              }, {
                '日期': '20',
                '数量': 7
              },
              {
                '日期': '21',
                '数量': 11
              }, {
                '日期': '22',
                '数量': 6
              },
              {
                '日期': '23',
                '数量': 12
              }, {
                '日期': '24',
                '数量': 5
              },
              {
                '日期': '25',
                '数量': 13
              }, {
                '日期': '26',
                '数量': 11
              },
              {
                '日期': '27',
                '数量': 14
              }, {
                '日期': '28',
                '数量': 13
              },
              {
                '日期': '29',
                '数量': 16
              }, {
                '日期': '30',
                '数量': 14
              }
            ]
          }
          break;
        default:
          this.is = "ve-line";
          this.chartData = {
            columns: [],
            rows: []
          }
          break;
      }
      this.$getJSON('/dbapi/s_s_s', {
        table: 'fm_t_whitelist',
        fields: 'name,frequency'
      }).then(
        res => {
          // console.log(JSON.stringify(res) );
          this.rows = res;
        }
      )
    },
    data() {
      this.chartSettings = {};
      this.grid = {
        top: 10,
        left: 0,
        right: 0,
        bottom: 0
      };
      this.toolbox = {
        feature: {
          saveAsImage: {}
        }
      };
      //this.colors = ['#2C363B','#d48265', '#91c7ae','#749f83','#ca8622', '#bda29a','#6e7074','#546570', '#c4ccd3']
      return {
        is: "ve-line",
        chartData: {
          columns: [],
          rows: []
        }
      };
    }
  };

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Chart_.vue